import config from '@/config';
import {ApiBase, InternationalizedField} from '@/api/common';

const NO_UPLOAD_FIELDS = [
    'positive_image_link',
    'negative_image_link',
];

export default class OutcomeFeedback extends ApiBase<OutcomeFeedback> {
    public static readonly SLUG: string = 'outcome-feedback';
    private static readonly URL_BASE: string = config.API_ROOT + '/outcome-feedback/';

    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public threshold?: number = undefined;
    public positive_image_path?: number = undefined;
    public positive_image_link?: string = undefined;
    public negative_image_path?: number = undefined;
    public negative_image_link?: string = undefined;
    public parent_lesson?: number = undefined;
    public positive_feedback_i18n: InternationalizedField<string> = new InternationalizedField<string>();
    public negative_feedback_i18n: InternationalizedField<string> = new InternationalizedField<string>();

    public constructor() {
        super({
            urlBase: OutcomeFeedback.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }

    public assign(response: any): OutcomeFeedback {
        super.assign(response);
         if (response) {
             if ('positive_feedback_i18n' in response) {
                 this.positive_feedback_i18n = new InternationalizedField<string>(response.positive_feedback_i18n);
             }
             if ('negative_feedback_i18n' in response) {
                 this.negative_feedback_i18n = new InternationalizedField<string>(response.negative_feedback_i18n);
             }
         }
        return this;
    }
}
